<template>
  <div class="content-bar-x-chart col-12">
    <div class="col-xs-12 col-12 col-sm-10 col-sm-offset-1 col-md-8 col-md-offset-2 mb-15 offset-md-2 offset-sm-1">
      <div class="content-bar-x-chart__header">
        <h3>{{ content.title }}</h3>

        <p>{{ content.subtitle }}</p>

        <div class="row">
          <div class="col-xs-12 col-md-6 bar-x-chart-header__controls">
            <select-filter
              v-model="selectedCountry"
              :selections="countries"
              :fluid="true"
              label="Select country"
              :label-icon="true"
              tagging-attr="visualization4"
              style="margin: 0px !important"
            />
          </div>
        </div>
      </div>

      <!-- chart here -->
      <div class="content-bar-x-chart__chart">
        <BarChartViz :country="selectedCountry" @data-sanitized="loadData" />
      </div>
    </div>
  </div>
</template>

<script>
import SelectFilter from '@/components/ui/SelectFilter.vue';

export default {
  name: 'BarChart',
  components: {
    SelectFilter,
    BarChartViz: () => import('@/components/content/chapter2/charts/BarChartViz.vue'),
  },
  props: {
    content: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      loadedData: [],
      selectedCountry: 'ASEAN-6',
    };
  },
  computed: {
    countries() {
      return this.loadedData.map((d) => d.country);
    },
  },
  methods: {
    loadData(data) {
      // get unique objects by "type" prop
      this.loadedData = [...new Map(data.map(({ country }) => [country, { country }])).values()];
    },
  },
};
</script>

<style lang="scss" scoped>
.content-bar-x-chart {
  background-color: #ffffff;
  padding: 60px 0;

  @media #{map-get($media-breakpoints, 'mobile')} {
    padding: 30px 0;
  }

  &__header {
    margin-bottom: 30px;
    @media #{map-get($media-breakpoints, 'mobile')} {
      margin-bottom: 15px;
    }
  }
}
</style>
